import template from './ko-field-input-password.html';

class PasswordInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
		this.auto_select = ko.observable(params.ui_fields?.auto_select ?? params.auto_select ?? false);
		this.show_password = ko.observable(false);

		this.togglePassword = this.togglePassword.bind(this);
	}

	togglePassword()
	{
		this.show_password(!this.show_password());
	}
}


export default {
	name: 'ko-field-input-password',
	viewModel: PasswordInputComponentVM,
	module_type: 'ko',
	template: template
}
